import {
  AbsoluteCenter,
  Flex,
  ProgressCircle,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  calculatePercentage,
  getColorBasedOnPercentage,
} from "../../../services/Utils";
interface Props {
  value: number;
  max: number;
  isloading: boolean;
}
export default function CompleteResultsChart({ value, max, isloading }: Props) {
  //if(value === 0 || max === 0) return <ErrorAlert message="No results yet" status='info'/>

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"space-evenly"}
      gap={5}
      w={"full"}
    >
      {(() => {
        let percentage = calculatePercentage(value, max);
        let color = getColorBasedOnPercentage(percentage);
        return (
          <>
            <ProgressCircle.Root
              max={max > 0 ? max : 1}
              value={isloading ? null : value > 0 ? value : 1}
              rounded={"full"}
              size={"xl"}
              colorPalette={color}
            >
              <ProgressCircle.Circle>
                <ProgressCircle.Track />
                <ProgressCircle.Range strokeLinecap="round" />
              </ProgressCircle.Circle>
              <AbsoluteCenter>
                <ProgressCircle.ValueText />
              </AbsoluteCenter>
            </ProgressCircle.Root>
            <Stack pr={10}>
              <Text fontWeight={"bold"}>Completed Results</Text>
              <Text fontSize={"sm"}>
                {value} of {max} result entries for the current term and
                session.
              </Text>
            </Stack>
          </>
        );
      })()}
    </Flex>
  );
}
